import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { CaoService } from 'src/app/services/cao.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { IpAddressService } from 'src/app/services/ip-address.service';


@Component({
  selector: 'app-failed-mi-payment',
  templateUrl: './failed-mi-payment.component.html',
  styleUrls: ['./failed-mi-payment.component.scss']
})
export class FailedMiPaymentComponent implements OnInit {

  dropDownList: { type: any, value: any }[];
  applicationSelected: any;
  responseDate: any;
  cols: any[];

  constructor(
    private route: ActivatedRoute,
    private ipService: IpAddressService, 
    private caoService: CaoService, 
    private messageService: MessageService, 
    private router: Router,
    private activityRecordService: ActivityRecordService,
    private cryptoJsService: CryptoJsService
    ) { }

  autoId: any;
  appId: any;
  items: any[];
  userID: any;

  ngOnInit(): void {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;
    this.activityRecordService.activityRecord(this.userID, 'Failed MI Payment', '', new Date(), 'Success');

    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams

    // if(this.router.url.startsWith('/ew-department')){
    //   this.dropDownList = [
    //     // {
    //     //   type: 'Farmer Share To Vendor', value: `/all-subsidy-lot/mi-farmer-share-to-vendor/pfms`
    //     // },
    //     // {
    //     //   type: 'Subsidy To Farmer', value: `/all-subsidy-lot/mi-subsidy-to-farmer/pfms`
    //     // },
    //     // {
    //     //   type: 'Subsidy To Vendor', value: `/all-subsidy-lot/mi-subsidy-to-vendor/pfms`
    //     // },
    //     // {
    //     //   type: 'Refund To Farmer', value: `/all-subsidy-lot/mi-refund-to-farmer/pfms`
    //     // },
    //     {
    //       type: 'Stage 1 (PDMC)', value: `/all-subsidy-lot/pond/tank-stage1/pdmc`
    //     },
    //     {
    //       type: 'Stage 1 (ABY)', value: `/all-subsidy-lot/pond/tank-stage1/aby`
    //     },
    //     {
    //       type: 'Stage 2 (PDMC)', value: `/all-subsidy-lot/pond/tank-stage2/pdmc`
    //     },
    //     {
    //       type: 'Stage 2 (ABY)', value: `/all-subsidy-lot/pond/tank-stage2/aby`
    //     },
    //     {
    //       type: 'Stage 3 (PDMC)', value: `/all-subsidy-lot/pond/tank-stage3/pdmc`
    //     },
    //     {
    //       type: 'Stage 3 (ABY)', value: `/all-subsidy-lot/pond/tank-stage3/aby`
    //     },
    //   ]
    // }
    // else{
    //   this.dropDownList = [
    //     {
    //       type: 'Farmer Share To Vendor (PDMC)', value: `/all-subsidy-lot/mi-farmer-share-to-vendor/pdmc`
    //     },
    //     // {
    //     //   type: 'Farmer Share To Farmer (ABY)', value: `/all-subsidy-lot/mi-farmer-share-to-farmer/aby`
    //     // },
    //     {
    //       type: 'Subsidy To Farmer (PDMC)', value: `/all-subsidy-lot/mi-subsidy-to-farmer/pdmc`
    //     },
    //     {
    //       type: 'Subsidy To Farmer (ABY)', value: `/all-subsidy-lot/mi-subsidy-to-farmer/aby`
    //     },
    //     {
    //       type: 'Subsidy To Vendor (PDMC)', value: `/all-subsidy-lot/mi-subsidy-to-vendor/pdmc`
    //     },
    //     // {
    //     //   type: 'Subsidy To Vendor (ABY)', value: `/all-subsidy-lot/mi-subsidy-to-vendor/aby`
    //     // },
    //     {
    //       type: 'Refund To Farmer (PDMC)', value: `/all-subsidy-lot/mi-refund-to-farmer/pdmc`
    //     },
    //     // {
    //     //   type: 'Refund To Farmer (ABY)', value: `/all-subsidy-lot/mi-refund-to-farmer/aby`
    //     // },
    //     // {
    //     //   type: 'Stage 1', value: `/all-subsidy-lot/pond/tank-stage1/pfms`
    //     // },
    //     // {
    //     //   type: 'Stage 2', value: `/all-subsidy-lot/pond/tank-stage2/pfms`
    //     // },
    //     // {
    //     //   type: 'Stage 3', value: `/all-subsidy-lot/pond/tank-stage3/pfms`
    //     // },
    //   ]
    // }
    
    this.dropDownList = [
      // {
      //   type: 'Select', value: null
      // },
      {
        type: 'Farmer Share To Vendor', value: `/failed-mi-payment/fsv`
      },
      {
        type: 'Subsidy To Farmer', value: `/failed-mi-payment/stf`
      },
      {
        type: 'Subsidy To Vendor', value: `/failed-mi-payment/stv`
      },
      {
        type: 'Refund To Farmer', value: `/failed-mi-payment/rtf`
      },
      // {
      //   type: 'Stage 1 (PDMC)', value: `/all-subsidy-lot/pond/tank-stage1/pdmc`
      // },
      // {
      //   type: 'Stage 1 (ABY)', value: `/all-subsidy-lot/pond/tank-stage1/aby`
      // },
      // {
      //   type: 'Stage 2 (PDMC)', value: `/all-subsidy-lot/pond/tank-stage2/pdmc`
      // },
      // {
      //   type: 'Stage 2 (ABY)', value: `/all-subsidy-lot/pond/tank-stage2/aby`
      // },
      // {
      //   type: 'Stage 3 (PDMC)', value: `/all-subsidy-lot/pond/tank-stage3/pdmc`
      // },
      // {
      //   type: 'Stage 3 (ABY)', value: `/all-subsidy-lot/pond/tank-stage3/aby`
      // },
    ]

    this.applicationSelected = {
      type: 'Farmer Share To Vendor', value: `/failed-mi-payment/fsv`
    }
    this.onApplicationTypeSelected({value: this.applicationSelected})
    // console.log(this.applicationSelected)
  }

  onApplicationTypeSelected(event) {
    let parentRoute = this.router.url.split('/')[1];
    this.router.navigate([`/${parentRoute.concat(event.value.value)}`])
  }

}

